import { useQuery } from '@apollo/client';
import { HubConnectionBuilder } from '@microsoft/signalr';
import axios from 'axios';
import { useEffect, useState } from 'react';
import GET_CURRENT_USER from '../features/shared/queries/currentUserQuery.js';
import { getAccessToken } from '../utils/auth.js';
import MESSAGE_TARGETS from './constants/signalRMessageTargets.js';

const useSignalRConnection = () => {
  const [connection, setConnection] = useState(null);

  const { data } = useQuery(GET_CURRENT_USER, {
    skip: !getAccessToken()
  });

  const createHubConnection = async userId => {
    const response = await axios.post(
      `${process.env.API_BASE_URL}/signalr-negotiate`,
      null,
      getAxiosConfig(userId)
    );

    const options = {
      accessTokenFactory: () => response.data.accessToken
    };

    //build signalr connection
    return new HubConnectionBuilder()
      .withUrl(response.data.url, options)
      .withAutomaticReconnect()
      .build();
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    createHubConnection(data.currentUser.Id).then(connectionRef => setConnection(connectionRef));
  }, [data]);

  useEffect(() => {
    if (!connection) {
      return;
    }

    try {
      connection.start();

      // listens to the corresponding target
      connection.on(MESSAGE_TARGETS.APPRAISAL, resp => {
        console.log('appraisal topic message:', resp);
      });
    } catch (error) {
      console.log('Connection failed: ', error);
    }

    return () => {
      connection.stop();
    };
  }, [connection]);

  return connection;
};

const getAxiosConfig = userId => {
  const config = {
    headers: {
      'user-id': userId,
      authorization: getAccessToken() ? `Bearer ${getAccessToken()}` : ''
    }
  };
  return config;
};

export default useSignalRConnection;
